import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, LineClamp } from '../../global/commonStyle';

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  overflow: hidden;
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    border: none;
    background: transparent;
    margin-bottom: var(--space-96);
  `)}
`;

export const ViewItem = styled.div`
  ${FlexBetween}
  background-color: var(--background-primary);
  border-bottom: 0.5px solid var(--border-primary);
  color: var(--text-secondary);
  gap: var(--space-20);
  padding: var(--space-8) var(--space-16);
  cursor: pointer;
  :first-child {
    background-color: var(--background-tertiary);
    &:hover {
      background-color: var(--background-tertiary);
      cursor: unset;
    }
  }
  :last-child {
    border-bottom: none;
  }
  .active-dropdown {
    background: var(--background-muted);
    border-radius: var(--border-radius-6);
  }
  .more-icon {
    &:hover {
      background: var(--background-muted);
    }
  }
  &:hover {
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    padding: var(--space-12) var(--space-0);
    border-bottom: none;
    background: transparent;
    align-items: flex-start;
    :first-child {
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }
    }
    &:hover {
      background: transparent;
      cursor: default;
    }
  `)}
`;

export const UserName = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 200px;
  ${Typography.body_md_medium}
  :first-child {
    width: 100%;
  }
  p {
    color: var(--text-primary);
    margin: var(--space-0);
  }
  span {
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    span {
      ${LineClamp(1)}
      text-overflow: ellipsis;
    }
  `)}
`;

export const ViewItemLeftSection = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  flex: 2;
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;

export const BlankDiv = styled.div`
  width: 32px;
  height: 1px;
`;

export const AvatarsGroup = styled.div`
  ${AlignCenter}
  gap: var(--space-0);
`;

export const AvatarWrapper = styled.div`
  border-radius: var(--border-radius-full);
  overflow: hidden;
  ${FlexCenter}
  margin-left: -8px;
  &:first-child {
    margin-left: var(--space-0);
  }
`;

export const PlusAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
  color: var(--text-primary);
  ${FlexCenter}
  font-weight: 600;
  border: 1px solid var(--background-primary);
  margin-left: -8px;
  z-index: var(--z-index-base);
`;
